export const CATALOG_VIEWS_DIRECTORY = "views" as const;
export const CATALOG_TEMP_VIEW_ID = "temp-view" as const;
